class BlogSlider extends HTMLElement {
  constructor() {
    super();
    this.flkty = null;
    this.resizeHandler = this.calculateHeights.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.flkty) {
      this.flkty.destroy();
    }
    window.removeEventListener('resize', this.resizeHandler);
  }

  init() {
    const sliderContainer = this.querySelector('.blog-slider-container');
    if (!sliderContainer) return;

    this.flkty = new Flickity(sliderContainer, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: false,
      groupCells: true,
      adaptiveHeight: false,
      setGallerySize: true,
      imagesLoaded: true,
      on: {
        ready: () => {
          this.calculateHeights();
          this.updateNavState();
        },
      },
    });

    this.prevButton = this.querySelector('[data-carousel-prev]');
    this.nextButton = this.querySelector('[data-carousel-next]');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.flkty.previous();
        this.updateNavState();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.flkty.next();
        this.updateNavState();
      });
    }

    this.flkty.on('change', () => this.updateNavState());
    window.addEventListener('resize', this.resizeHandler);

    this.updateNavState();
  }

  calculateHeights() {
    if (!this.flkty) return;

    const slides = this.querySelectorAll('.blog-slider__item');
    let maxHeight = 0;

    slides.forEach((slide) => (slide.style.height = 'auto'));

    slides.forEach((slide) => {
      maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });

    slides.forEach((slide) => (slide.style.height = `${maxHeight}px`));

    this.flkty.resize();
  }

  updateNavState() {
    if (!this.flkty) return;

    const atFirst = this.flkty.selectedIndex === 0;
    const atLast = this.flkty.selectedIndex === this.flkty.slides.length - 1;

    if (this.prevButton) {
      this.prevButton.disabled = atFirst;
      this.prevButton.setAttribute('aria-disabled', atFirst);
    }

    if (this.nextButton) {
      this.nextButton.disabled = atLast;
      this.nextButton.setAttribute('aria-disabled', atLast);
    }
  }
}

if (!customElements.get('blog-slider')) {
  customElements.define('blog-slider', BlogSlider);
}
